import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Heading from '@bibliocommons/heading';
import { catalogBibShape, recommendationShape } from '@bibliocommons/bc-prop-types';
import { SecondaryGhostLink } from '@bibliocommons/base-links';
import RecommendationItem from './RecommendationItem';

import './Recommendations.scss';

export default class Recommendations extends React.PureComponent {
  renderGroupedRecommendations() {
    const groupedRecommendations = this.props.recommendations.groupBy(recommendation =>
      recommendation.get('providerName')
    );

    return groupedRecommendations
      .map(items =>
        items.map((item, itemIndex) => {
          return <RecommendationItem item={item} itemIndex={itemIndex} key={item.get('id')} />;
        })
      )
      .valueSeq();
  }

  render() {
    const { catalogBib, recommendations } = this.props;
    const metadataId = catalogBib.get('metadataId');
    if (!recommendations.size) return null;

    return (
      <div className="cp-bib-recommendations">
        <Heading tagName="h2" size="moderate" variant className="group-title">
          <FormattedMessage id="recommendations_may_also_like" />
        </Heading>
        <div className="groups">{this.renderGroupedRecommendations()}</div>

        <SecondaryGhostLink
          className="view-all-recommendations-link"
          href={`/v2/record/${metadataId}/recommendations`}
          dataKey="recommendations-view-all-link"
        >
          <FormattedMessage id="view_all_recommendations" />
        </SecondaryGhostLink>
      </div>
    );
  }
}

Recommendations.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  recommendations: ImmutablePropTypes.listOf(recommendationShape).isRequired
};
